module.exports = __webpack_public_path__ + "img/dropbox.458c5180.svg";